export default __webpack_public_path__ + "static/media/Button Right.2ad72c18.svg";